module.exports = __webpack_public_path__ + "media/images/share_facebook-2ceff7f6c1ede34c120f9b933c8343ba.svg";